import React, { PropTypes } from 'react';
import ServicesLayout from '../components/ServicesLayout';

const layoutWrapper = (props, children) =>
  <ServicesLayout {...props} >
    {children}
  </ServicesLayout>;

export default layoutWrapper;



// WEBPACK FOOTER //
// src/hocs/layoutWrapper.js